import { DateTime } from 'luxon';
import { v4 as uuidv4 } from 'uuid';

const recurringTransactions = (account) => {
  const postedOnDate = DateTime.local().minus({ days: 1 });
  const postedOn = postedOnDate.toISODate();

  const baseTransaction = {
    source: 'QCS_REFRESH',
    accountId: account?.id,
    postedOn,
    payee: 'AT&T',
    coa: {
      type: 'UNCATEGORIZED',
      id: '0',
    },
    amount: -120,
    state: 'CLEARED',
    matchState: 'NOT_MATCHED',
    cpData: {
      id: uuidv4(),
      cpPendingId: uuidv4(),
      postedOn,
      txnOn: postedOn,
      amount: -120,
      payee: 'AT&T',
      inferredPayee: 'AT&T',
      inferredCoa: {
        type: 'UNCATEGORIZED',
        id: '0',
      },
      cpCategoryId: '2002',
    },
    type: 'CASH_FLOW',
  };
  return [...Array(12)].map((transaction, index) => ({
    ...baseTransaction,
    ...transaction,
    postedOn: postedOnDate.minus({ months: index }).toISODate(),
    cpData: {
      ...baseTransaction.cpData,
      id: uuidv4(),
      cpPendingId: uuidv4(),
      postedOn: postedOnDate.minus({ months: index }).toISODate(),
    },
  }));
};

export default recurringTransactions;
